import _ from 'lodash';

export const GETI18NBYKEY_PATH_EXCEPTION =
    '[i18n][getI18nByKey]: Param path must be a not empty string';
export const GETI18NBYKEY_PATH_PATTERN_EXCEPTION =
    '[i18n][getI18nByKey]: Param path must be valid json path(xxx.xxx.xxx)';
export const PATTERN_PATH_I18N = /^\w+(.\w+)*$/;

export const getI18n = state => state.i18n;
export const getI18nByKey = (state, path) => {
    if (!path) {
        throw new Error(GETI18NBYKEY_PATH_EXCEPTION);
    }
    if (!path.match(PATTERN_PATH_I18N)) {
        throw new Error(GETI18NBYKEY_PATH_PATTERN_EXCEPTION);
    }
    return _.get(getI18n(state), path);
};



// WEBPACK FOOTER //
// ./src/services/i18n/selector.js